import { IPublishOptions, IPublishTermsServices } from '../types';

export function updatePublishOptions(
  services: IPublishTermsServices,
  serviceId: string | null,
  publishOptions: Partial<IPublishOptions>,
): IPublishTermsServices {
  if (!serviceId || !services[serviceId]) {
    return services;
  }

  const currentService = services[serviceId];

  return {
    ...services,
    [serviceId]: {
      ...currentService,
      publishOptions: {
        ...currentService.publishOptions,
        ...publishOptions,
      },
    },
  };
}
